import { isTenantAdministrator } from './administratorAccess';

// Existing betriebe.read/manage policy, as used by article master maintenance.
export const canReadEinrichtungen = user => isTenantAdministrator(user)
  || Boolean(user?.roles?.some(role => role.key === 'VERWALTER'));
export const canManageEinrichtungen = isTenantAdministrator;
